import React, { FC } from 'react';
import urlJoin from 'url-join';
import { useHistory, useLocation } from 'react-router-dom';
import { Alert, Button } from '@clearcover/atlas';
import { Modal } from 'Shared/components';
import { QUOTE_APP_ROUTE } from 'Shared/constants/routes';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

export const OutdatedAppDataModal: FC = () => {
  const { appId } = useAppContext();
  const history = useHistory();
  const location = useLocation<{
    appDataStale?: boolean;
    rateChangeMessage?: string;
  }>();

  const close = () => {
    // this will remove the state from location
    history.replace(urlJoin(QUOTE_APP_ROUTE, appId, 'summary'));
  };

  return (
    <Modal showModal={!!location.state?.appDataStale} onClose={close}>
      <div className={styles.modalContainer}>
        <h1 className={styles.header}>Application Data Changed</h1>
        {location.state?.rateChangeMessage && (
          <Alert type="info" message={location.state?.rateChangeMessage} />
        )}
        <p className={styles.content}>
          The application data was out of date during checkout. We have fetched
          the most recent information; please review the Quote Summary and try
          again.
        </p>
        <div className={styles.footer}>
          <Button
            data-testid="close-outdated-data-modal-button"
            onClick={close}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};
